import * as React from 'react';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AppProviders } from './AppProviders';
import Routes from './scenes/routes';

function App() {
  return (
    <Suspense fallback={null}>
      <AppProviders>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </AppProviders>
    </Suspense>
  );
}

export { App };
